import { rootUiActions } from 'app-components/flux/root-ui';
// CUSTOM
import { getLogger } from 'app-components/utils/core';
// CORE
import { useMemo } from 'react';
import { useDispatch } from 'react-redux';

import * as ddata from './core';

const log = getLogger('components/QDialogs/index.js');

function useQDialogs() {
  const iconsOnDialogAlerts = true; // useSelector(featureFlagsSelectors.getFeatureFlags).get('iconsOnDialogAlerts');
  const dispatch = useDispatch();
  const createDialog = (data) => dispatch(rootUiActions.createDialog(data));

  const dialogAlertCustom = (props) => {
    // only this one takes on an object (props), all others take individual args   (argggh!)
    const dialogData = ddata.dialogAlertCustom({ ...props, iconsOnDialogAlerts });
    log.debug('Creating Dialog...', dialogData.toJS());
    createDialog(dialogData);
  };

  const dialogAlert = (...args) => {
    const dialogData = ddata.dialogAlert(...args, iconsOnDialogAlerts);
    log.debug('Creating Dialog...', dialogData.toJS());
    createDialog(dialogData);
  };

  const dialogPassword = (...args) => {
    const dialogData = ddata.dialogPassword(...args, iconsOnDialogAlerts);
    createDialog(dialogData);
  };

  const dialogForm = (...args) => {
    const dialogData = ddata.dialogForm(...args, iconsOnDialogAlerts);
    log.debug('Creating Dialog...', dialogData.toJS());
    createDialog(dialogData);
  };

  const returnVal = useMemo(
    () => ({
      dialogAlert,
      dialogForm,
      dialogPassword,
      dialogAlertCustom,
    }),
    [dispatch], // eslint-disable-line react-hooks/exhaustive-deps
  ); // only new dispatch requires new functions

  return returnVal;
}

export default useQDialogs;
